"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "VictoryLine", {
  enumerable: true,
  get: function () {
    return _victoryLine.default;
  }
});
Object.defineProperty(exports, "Curve", {
  enumerable: true,
  get: function () {
    return _curve.default;
  }
});

var _victoryLine = _interopRequireDefault(require("./victory-line"));

var _curve = _interopRequireDefault(require("./curve"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/victory-line/lib/index.js
// module id = 1890
// module chunks = 0